// extracted by mini-css-extract-plugin
module.exports = {"listicon":"listicon--3Z3d0"};